var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding.left",
      value: (3),
      expression: "3",
      modifiers: {
        "left": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.right",
      value: (3),
      expression: "3",
      modifiers: {
        "right": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.top",
      value: (2),
      expression: "2",
      modifiers: {
        "top": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "headline"
    }
  }, [_vm._v("\n            Подберите выгодный тарифный план\n        ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding.left",
      value: (3),
      expression: "3",
      modifiers: {
        "left": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.right",
      value: (3),
      expression: "3",
      modifiers: {
        "right": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.bottom",
      value: (3),
      expression: "3",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-alert', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (3),
      expression: "3",
      modifiers: {
        "bottom": true
      }
    }],
    attrs: {
      "info": ""
    }
  }, [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (2),
      expression: "2"
    }]
  }, [_c('div', [_c('v-text', {
    attrs: {
      "type": "subheadling"
    }
  }, [_vm._v("\n                        Как подобрать тариф\n                    ")])], 1), _vm._v(" "), _c('v-text', [_vm._v("\n                    Выберите инструменты проверки сотрудник/контрагента, которыми вы пользуетесь на UNIRATE24.\n                    Укажите предполагаемое количество проверок с помощью нашего сервиса.\n                    Система автоматически произведет расчет наиболее выгодного для вас тарифного плана\n                    и мотивирует рекомендацию.\n                ")])], 1)]), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "xs": "6"
    }
  }, [_c('v-form', {
    attrs: {
      "values": _vm.values,
      "readonly": _vm.isCalculating
    },
    on: {
      "submit": _vm.handleSubmit
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(api) {
        return [_c('v-row', {
          directives: [{
            name: "padding",
            rawName: "v-padding.bottom",
            value: (3),
            expression: "3",
            modifiers: {
              "bottom": true
            }
          }]
        }, [_c('v-col', {
          attrs: {
            "xs": "7"
          }
        }, [_c('v-text', {
          attrs: {
            "type": "caption"
          }
        }, [_vm._v("\n                                    Инструмент проверки\n                                ")])], 1), _vm._v(" "), _c('v-col', {
          attrs: {
            "xs": "5"
          }
        }, [_c('v-text', {
          attrs: {
            "type": "caption"
          }
        }, [_vm._v("\n                                    Колличество в месяц\n                                ")])], 1)], 1), _vm._v(" "), _vm._l((_vm.products), function(product) {
          return _c('v-row', {
            directives: [{
              name: "padding",
              rawName: "v-padding.bottom",
              value: (3),
              expression: "3",
              modifiers: {
                "bottom": true
              }
            }],
            key: product.id,
            attrs: {
              "align-items": "center"
            }
          }, [_c('v-col', {
            attrs: {
              "xs": "7"
            }
          }, [_c('v-text', [_vm._v("\n                                    " + _vm._s(product.name) + "\n                                ")])], 1), _vm._v(" "), _c('v-col', {
            attrs: {
              "xs": "5"
            }
          }, [_c('v-form-input', {
            attrs: {
              "field": product.id.toString(),
              "select": "",
              "items": _vm.items
            }
          })], 1)], 1)
        }), _vm._v(" "), _c('v-row', {
          directives: [{
            name: "padding",
            rawName: "v-padding.bottom",
            value: (3),
            expression: "3",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "align-items": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "xs": "7"
          }
        }, [(_vm.isLoadingRequests) ? _c('v-spinner') : _c('v-text', [_c('v-link', {
          attrs: {
            "to": "javascript:;"
          },
          on: {
            "click": _vm.handleFetchRequests
          }
        }, [_vm._v("\n                                        Подставить мои запросы за последний месяц\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-col', {
          attrs: {
            "xs": "5"
          }
        }, [_c('v-spinner', {
          attrs: {
            "active": _vm.isCalculating,
            "block": ""
          }
        }, [_c('v-button', {
          attrs: {
            "disabled": _vm.isLoadingRequests,
            "primary": "",
            "block": "",
            "type": "submit"
          }
        }, [_vm._v("\n                                        подобрать\n                                    ")])], 1)], 1)], 1)]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-animation-height', [(_vm.calculatedTariff) ? _c('div', [_c('v-separator'), _vm._v(" "), _c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (3),
      expression: "3"
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "headline"
    }
  }, [_vm._v("\n                    Выгодный тарифный план\n                ")]), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "xs": "7"
    }
  }, [_c('v-row', {
    attrs: {
      "align-items": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "xs": "6"
    }
  }, [_c('v-text', {
    attrs: {
      "type": "title",
      "medium": ""
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.calculatedTariff.title) + "\n                                ")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "6"
    }
  }, [(_vm.calculatedTariff.cost) ? _c('v-text', {
    attrs: {
      "type": "title",
      "medium": ""
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.numberWithSpaces(_vm.calculatedTariff.cost)) + " руб.\n                                ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.right",
      modifiers: {
        "right": true
      }
    }],
    attrs: {
      "xs": "5"
    }
  }, [_c('v-button', {
    directives: [{
      name: "margin",
      rawName: "v-margin.right",
      value: (3),
      expression: "3",
      modifiers: {
        "right": true
      }
    }],
    attrs: {
      "primary": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.isShowDetails = !_vm.isShowDetails
      }
    }
  }, [_vm._v("\n                            детали расчета\n                        ")]), _vm._v(" "), (_vm.calculatedTariff.cost) ? _c('v-router-link', {
    attrs: {
      "to": {
        name: 'tariffBuy',
        params: {
          tariff: _vm.calculatedTariff.id
        }
      }
    }
  }, [_c('v-button', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("\n                                купить\n                            ")])], 1) : _c('v-button', {
    attrs: {
      "primary": "",
      "disabled": ""
    }
  }, [_vm._v("\n                            купить\n                        ")])], 1)], 1), _vm._v(" "), (_vm.isShowDetails) ? _c('tariffs-table', {
    directives: [{
      name: "margin",
      rawName: "v-margin.top",
      value: (4),
      expression: "4",
      modifiers: {
        "top": true
      }
    }],
    attrs: {
      "tariffs": _vm.tariffs,
      "selected": _vm.calculatedTariff.id
    }
  }) : _vm._e()], 1)], 1) : _vm._e()])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-467202fe","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/tariffCalculate/TariffCalculate.vue
// module id = 968
// module chunks = 0